export const loginScreen = '/login';

export const dashboardScreen = '/';

export const uploadInvoiceScreen = '/upload';
export const invoicesScreen = '/invoices';
export const accountsScreen = '/accounts';
export const profileScreen = '/profile';
export const guideScreen = '/guide';
